var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"exchange_notice"},[_c('h3',[_vm._v("안내 사항")]),_c('ul',[_c('li',[_vm._v("현금캐시백의 경우 소득신고대상으로 포인트 획득 방법에 따라 3.3% ~ 22% 세금 공제 후 입금됩니다.")]),_c('li',[_vm._v("확정된 수령 금액은 포인트 전환 내역에서 확인할 수 있습니다.")]),_c('li',[_vm._v("현금 캐시백 신청은 한번 신청 후 취소가 불가능합니다.")])])])
}]

export { render, staticRenderFns }